import { create } from "zustand";
export const usePurchaseStore = create((set)=>({
        isModalOpen: false,
        modalProps: {},
        openModal: (content)=>set({
                isModalOpen: true,
                modalProps: content
            }),
        closeModal: ()=>set({
                isModalOpen: false,
                modalProps: undefined
            }),
        selectedTab: null,
        setSelectedTab: (tab)=>set({
                selectedTab: tab
            }),
        selectedPass: null,
        setSelectedPass: (pass)=>set({
                selectedPass: pass
            }),
        showCouponModal: false,
        showNotAvailablePassModal: false,
        showAvailableRelatedProductsModal: false,
        showSignInModal: false,
        setFlags: (flags)=>set(flags),
        reset: ()=>set({
                isModalOpen: false,
                modalProps: {},
                selectedTab: null,
                selectedPass: null,
                showCouponModal: false,
                showNotAvailablePassModal: false,
                showAvailableRelatedProductsModal: false,
                showSignInModal: false
            })
    }));
